var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0095 18.0982C5.00952 18.0982 1.05714 13.5458 2.07619 8.3744C2.69524 5.22202 5.2381 2.67917 8.38095 2.06964C13.5524 1.05059 18.1048 5.00298 18.1048 10.003C18.1048 14.4696 14.4762 18.0982 10.0095 18.0982ZM10.0095 20.003C15.9048 20.003 20.6095 14.8982 19.9429 8.86012C19.4381 4.28869 15.7143 0.56488 11.1429 0.0601169C5.11429 -0.60655 1.39044e-06 4.09821 8.7506e-07 9.99345C0.00952378 15.5268 4.48571 20.003 10.0095 20.003Z",
    fill: "fillColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.50974 15.7538L10.5097 15.7538C10.7859 15.7538 11.0097 15.5747 11.0097 15.3538L11.0097 8.15383C11.0097 7.93292 10.7859 7.75383 10.5097 7.75383L9.50974 7.75383C9.23359 7.75383 9.00974 7.93292 9.00974 8.15383L9.00974 15.3538C9.00974 15.5747 9.23359 15.7538 9.50974 15.7538Z",
    fill: "fillColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.53356 6.44109L10.4859 6.44109C10.7489 6.44109 10.9621 6.22789 10.9621 5.9649L10.9621 5.01251C10.9621 4.74952 10.7489 4.53632 10.4859 4.53632L9.53356 4.53632C9.27056 4.53632 9.05737 4.74952 9.05737 5.01251L9.05737 5.9649C9.05737 6.22789 9.27056 6.44109 9.53356 6.44109Z",
    fill: "fillColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.26b3383060a9e1b58e6a78ab5e9517cd.svg";
export { ForwardRef as ReactComponent };